   <app-payment-notice [canPay]="true" [entityType]="data.entityType" [feeType]="data.feeType"  [id]="data.id" [amount]="data.amount"></app-payment-notice>

  <div fxLayout="row" fxLayoutGap="16px" class="m-t-16">
    <button mat-raised-button type="button" (click)="cancel()">Close</button>
  </div>


